import React from "react";
import { RegisteredParticipantTable } from "./RegisteredParticipantResult";
import { GetGenericAccountsResponse } from "../../../../api/services/client/models";
import { RegisteredParticipantsTabContainer } from "./RegisteredParticipantsTab.style";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../helpers/constants";

interface RegisteredParticipantsTabType {
  data?: GetGenericAccountsResponse;
  isFromEditGenericAccount?: boolean;
}

const RegisteredParticipantsTab: React.FC<RegisteredParticipantsTabType> = ({
  data,
  isFromEditGenericAccount = false,
}) => {
  return (
    <RegisteredParticipantsTabContainer>
      <PermissionWrapper
        permission={
          MODULE_PERMISSIONS.GENERIC_ACCOUNT_VIEW_PARTICIPANT_INFORMATION
        }
      >
        <RegisteredParticipantTable
          rows={data?.participants || []}
          genericAccountId={data?.id}
          isFromEditGenericAccount={isFromEditGenericAccount}
        />
      </PermissionWrapper>
    </RegisteredParticipantsTabContainer>
  );
};

export default RegisteredParticipantsTab;
